import { render, staticRenderFns } from "./ItemCharmRequiredKeys.vue?vue&type=template&id=666822be&scoped=true&"
import script from "./ItemCharmRequiredKeys.vue?vue&type=script&lang=ts&"
export * from "./ItemCharmRequiredKeys.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCharmRequiredKeys.vue?vue&type=style&index=0&id=666822be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666822be",
  null
  
)

export default component.exports